module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAB5SURBVGhD7dZBEYAwDETRikABJ0RwRAAiGDQgAQWIQAuakoaZ1gKk6X8zK2AvmyQAwC9U9QyQ9S3SPBG5KOJJuCJ7gMxluwAA6Jxdxbv12Iuy8TR6QhFvapElQKayXQAAdM6u4hMgB0+jJxTxphYZA2Qo2wUA+FJKGcGeXRv5Ey18AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-hamburger-white.png
// module id = 1559
// module chunks = 0